"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _RequestAccessModal = _interopRequireDefault(require("../../../common/components/RequestAccess/RequestAccessModal/RequestAccessModal"));
var _APIGroupSLATierLimits = _interopRequireDefault(require("./APIGroupSLATierLimits"));
var _UnderlyingAPITermsList = _interopRequireDefault(require("./UnderlyingAPITermsList"));
var styles = {
  "underlying-label": "RequestAPIGroupAccessModal__underlying-label__1mbPq",
  "underlyingLabel": "RequestAPIGroupAccessModal__underlying-label__1mbPq"
}; 
require('./RequestAPIGroupAccessModal.css');
var RequestAPIGroupAccessModal = function RequestAPIGroupAccessModal(props) {
  var asset = props.asset,
    hasUnderlyingTerms = props.hasUnderlyingTerms;
  var renderSLATiers = function renderSLATiers(_ref) {
    var slaTiers = _ref.slaTiers,
      slaTier = _ref.slaTier;
    var limitsByAPI = slaTiers.find(function (_ref2) {
      var id = _ref2.id;
      return id.toString() === slaTier;
    }).limitsByApi;
    return /*#__PURE__*/_react.default.createElement(_APIGroupSLATierLimits.default, {
      limitsByAPI: limitsByAPI
    });
  };
  var renderUnderlyingTerms = function renderUnderlyingTerms(_ref3) {
    var apiGroupInstanceId = _ref3.apiGroupInstanceId;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasUnderlyingTerms ? /*#__PURE__*/_react.default.createElement("span", {
      className: styles.underlyingLabel,
      "data-test-id": "underlying-apis-terms-label"
    }, "The following underlying APIs also include terms and conditions.") : null, /*#__PURE__*/_react.default.createElement(_UnderlyingAPITermsList.default, {
      asset: asset,
      apiGroupInstanceId: apiGroupInstanceId
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_RequestAccessModal.default, (0, _extends2.default)({}, props, {
    renderSLATiers: renderSLATiers,
    renderUnderlyingTerms: renderUnderlyingTerms
  }));
};
var _default = exports.default = RequestAPIGroupAccessModal;
//# sourceMappingURL=RequestAPIGroupAccessModal.js.map